import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { SkeletonRows } from '@components/table';
import { EmptyRow } from '@components/table/EmptyRow';
import { fonts } from '@theme/fontsCustomer';
import type { ScimTokenModel } from '@repositories/scimTokenRepository/models/ScimTokenModel';
import { ScimTokenTableRow } from './ScimTokenTableRow';

type Props = {
  tokens: ScimTokenModel[];
  isLoading: boolean;
  tenantId: string;
};

const COLUMN_COUNT = 5;

export const ScimTokenTable = ({ tokens, isLoading, tenantId }: Props) => {
  const { t } = useTranslation();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <StyledHeadCell align="left">{t('ScimToken.table.description')}</StyledHeadCell>
            <StyledHeadCell align="left">{t('ScimToken.table.status')}</StyledHeadCell>
            <StyledHeadCell align="left">{t('ScimToken.table.expiresAt')}</StyledHeadCell>
            <StyledHeadCell align="left">{t('ScimToken.table.createdDate')}</StyledHeadCell>
            <StyledHeadCell align="left">{t('ScimToken.table.lastUsedAt')}</StyledHeadCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <SkeletonRows rowNum={3} colNum={COLUMN_COUNT} />
          ) : tokens.length === 0 ? (
            <EmptyRow colSpan={COLUMN_COUNT} title={t('ScimToken.empty')} />
          ) : (
            tokens.map(token => (
              <ScimTokenTableRow key={token.id} token={token} tenantId={tenantId} />
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const StyledHeadCell = styled(TableCell)`
  ${fonts.Body4};
  color: ${({ theme: { colors } }) => colors['text-gray-sub-dark']};
  background-color: ${({ theme: { colors } }) => colors['bg-gray-lighter']};
`;
